import { ReactElement } from "react";

import { Button, ButtonProps, Text } from "@chakra-ui/react";

const ResendInvite = ({
  isLoading,
  onClick,
}: Pick<ButtonProps, "isLoading" | "onClick">): ReactElement => {
  return (
    <Button
      isLoading={isLoading}
      isDisabled={isLoading}
      onClick={onClick}
      variant="link"
    >
      <Text textStyle="label2" color="inherit">
        PENDING - RESEND INVITE
      </Text>
    </Button>
  );
};

export default ResendInvite;
